  import React from 'react'
import clsx from 'clsx'
import './Home.scss'
import Header from '../../components/Header'
import Hall from '../../components/Hall'
import ContactModal from '../../components/ContactModal'
import ContactModalContext, { useContactModalProvider } from '../../components/ContactModal/useContactModal'

const Home = () => {
  const modal = useContactModalProvider()
  return (
    <ContactModalContext.Provider value={modal}>
      <div className={clsx('Home')}>
        <Header/>
        <Hall/>
        <ContactModal />
      </div>
    </ContactModalContext.Provider>
  )
}
export default Home
